// eslint-disable-next-line no-extra-semi
;(function () {
  function zoomButton() {
    var zoomInTemplate =
      '<a ng-click="zoomIn()" disabled="{{zoomInDisabled}}" class="zoom zoom_in"></a>'
    //var zoomOutTemplate = '<a ng-click="zoomOut()" disabled="{{zoomOutDisabled}}" class="zoom zoom_out"></a>';
    return {
      restrict: 'AE',
      scope: {
        type: '@',
        disabled: '@',
      },
      template: zoomInTemplate,
      link: function (scope, element, attrs) {},
    }
  }
  bz_app.directive('zoomButton', zoomButton)
})()
